/** @jsxImportSource @emotion/react */
import { jsx } from "@emotion/react";
import {getMetricValues, GetTriageDetails} from "../../../DoctorsModule/ReusableTreatmentHistory";
import {borderedTriage, table} from "../../../../styles/tableStyles";
import {convertDateStrokeTime} from "../../../Utils/ConvertDate";
import React from "react";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages} from "../../../../Helpers/ErrorMessages";

export const RecordedTriage = ({actions, patientTriage, setPatientTriage, visit_id, patient_number,isSubmitted, setIsSubmitted}) => {

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? "" : _token.user_roles_id;


    const handleEditTriage = (index) =>{
        const arr = patientTriage?.map((item, idx)=>{
            if (index === idx){
                return {...item, isEdit:true}
            }
            return item
        })
        setPatientTriage(arr)
    }

    const handleCancelEditTriage = (index) =>{
        const arr = patientTriage?.map((item, idx)=>{
            if (index === idx){
                return {...item, isEdit:false}
            }
            return item
        })
        setPatientTriage(arr)
    }

    const handleChangeValue = (event, index, metric_id) =>{
        const arr = patientTriage?.map((item, idx)=>{
            if (index === idx){
                return {...item, data:item?.data?.map(metric=>{
                        if (metric.metric_id === metric_id){
                            return {...metric, metric_value:event.target.value}
                        }
                        return metric
                    })
                }
            }
            return item
        })
        setPatientTriage(arr)
    }


    const handleSubmitTriage = (data, index) => {
        const jsonData = {
            patient_number,
            visit_id,
            visit_state:3,
            activity_id: '',
            user_roles_id,
            chronic_illness: {},
            allergies: '',
            metric_type_id:1,
            triage_info:data

        }
        setIsSubmitted('pending');
        axios.post(`${config.smsUrl}/cvisit/update_triage`, jsonData).then(() => {
            setIsSubmitted('resolved');
            actions.snackbarActions.snackSuccess('Triage Information added successful');
            const arr = patientTriage?.map((item, idx)=>{
                if (index === idx){
                    return {...item, isEdit:false}
                }
                return item
            })
            setPatientTriage(arr)
        }).catch((err) => {
            errorMessages(err, null, actions)
            setIsSubmitted('rejected');
        });

    }

    const isPending = isSubmitted === 'pending'

    const { metrics_titles, percentage_metrics } = GetTriageDetails(patientTriage);

    return(
        <div className="table-responsive">
            <table css={[table, borderedTriage]}>
                <thead>
                <tr>
                    <td rowSpan={2} style={{ textAlign: "center", padding: "5px" }}>
                        <strong>Date</strong>
                    </td>
                    <td
                        colSpan={metrics_titles.length}
                        style={{ textAlign: "center", padding: "5px" }}
                    >
                        <strong>Metrics</strong>
                    </td>
                    <td
                        className="print_button"
                        rowSpan={2}
                        style={{ textAlign: "center", padding: "2px" }}
                    >
                        <strong>Action</strong>
                    </td>
                </tr>
                <tr>
                    {metrics_titles.map((it) => (
                        <td
                            key={it.metric_id}
                            style={{ textAlign: "center", padding: "5px" }}
                        >
                <span style={{ margin: "3px" }}>
                  <strong>{`${it.metric_name} ${
                      it.uom ? `(${it.uom})` : ""
                  }`}</strong>
                </span>
                        </td>
                    ))}
                </tr>
                </thead>
                <tbody>
                {patientTriage.map((element, index) => {
                    const saveButtons = (
                        <>
                            <button
                                type="submit"
                                className="btn btn-sm sms-btn small-btn mr-3"
                                onClick={() => handleSubmitTriage(element.data, index)}
                                style={{ marginTop: "5px", marginBottom: "5px" }}
                            >
                                {isPending ? "Saving..." : "Save"}
                            </button>
                            <button
                                type="submit"
                                className="btn btn-sm sms-gray-btn small-btn"
                                onClick={() => handleCancelEditTriage(index)}
                                style={{ marginTop: "5px", marginBottom: "5px" }}
                            >
                                Cancel
                            </button>
                        </>
                    );
                    return (
                        <tr key={index}>
                            <td style={{ textAlign: "center", padding: "5px" }}>
                  <span style={{ margin: "3px" }}>
                    {convertDateStrokeTime(element.metric_date)}
                  </span>
                            </td>
                            {metrics_titles.map((it, idx) =>
                                getMetricValues(
                                    element.data,
                                    it.metric_name,
                                    percentage_metrics,
                                    element.isEdit,
                                    handleChangeValue,
                                    index
                                )
                            )}
                            <td
                                className="print_button"
                                style={{ textAlign: "center", padding: "2px" }}
                            >
                                {element.isEdit ? (
                                    saveButtons
                                ) : (
                                    <button
                                        type="submit"
                                        className="btn btn-sm sms-amber-btn small-btn "
                                        onClick={() => handleEditTriage(index)}
                                        style={{ marginTop: "5px", marginBottom: "5px" }}
                                    >
                                        Edit
                                    </button>
                                )}
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};